import React, { useState, useRef } from 'react'

// import { LoginService } from '../service/LoginService'
import { Logo } from '../components/logo'
import { Toast } from 'primereact/toast';
import { useStore } from '../stores/GlobalStore'
import { loginRequest } from '../apis/calyxSaaSDashboardAPI'
import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import axios, { AxiosResponse } from 'axios'
import { StatusCodes } from 'http-status-codes';


import '../assets/login.css'

export const Login = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const { state, dispatch } = useStore()
  const toast = useRef(null)

  const { data, refetch, isFetching, isLoading } = useQuery(['login', {
    email, password
  }], () => {
    return loginRequest({
      email, password
    })
  }, {
    enabled: false,
    refetchOnWindowFocus: false,
    retry: 0,
    onSuccess: (data) => {
      dispatch({
        type: 'LOGIN',
        payload: data,
        callback: () => { console.log(`[callback]login success, state = ${JSON.stringify(state)}`) }
      })
    },
    onError: (err) => {
      if (axios.isAxiosError(err)) {
        if (err?.response?.status === StatusCodes.UNAUTHORIZED) {
          toast.current.show({severity: 'error', summary: 'Invalid account or wrong password', life: 5000});
        } else if(err?.response?.status === StatusCodes.INTERNAL_SERVER_ERROR){
          toast.current.show({severity: 'error', summary: 'Internal server error', life: 5000});
        } else {
          toast.current.show({severity: 'error', summary: `Unkown Error, status code: ${err?.response?.status}`, life: 5000});
        }
      } else {
        toast.current.show({severity: 'error', summary: 'Unkown Error', life: 5000});
      }
    }
  })

  const handleEmailChange = (e) => {
    setEmail(e.target.value)
  }
  const handlePassChange = (e) => {
    setPassword(e.target.value)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (isFetching) return
    refetch();
  }

  return (
    <>
      <Toast ref={toast} />
      <div className='bg-login'>
        <div className='row login h-100'>
          <div className='col-lg-6'>
            <div className='text-center'>
              <Logo />
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='login-form'>
              <form onSubmit={handleSubmit}>
                {/* <label>User Name</label> */}
                <input className='my-2 form-control' placeholder='Email' type='text' data-test-id='loginEmail' value={email} onChange={handleEmailChange} />

                {/* <label>Password</label> */}
                <input className='my-2 form-control' placeholder='Password' type='password' data-test-id='loginPassword' value={password} onChange={handlePassChange} />
                <br />
                {/* <input className="my-1 btn mt-4 default" type='submit' value='Log In' data-test='submit' /> */}
                <button className='my-1 btn mt-4 default' data-test-id='loginButton'>Login</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
